import { render, staticRenderFns } from "./FertilizationType.vue?vue&type=template&id=3bc7ea9c&scoped=true&lang=html&"
import script from "./FertilizationType.vue?vue&type=script&lang=js&"
export * from "./FertilizationType.vue?vue&type=script&lang=js&"
import style0 from "./FertilizationType.vue?vue&type=style&index=0&id=3bc7ea9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc7ea9c",
  null
  
)

export default component.exports